import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopADSR = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const adsrFeatures = [
        {
            id: 1,
            image: "/assets/software-partners/adsr/salesReport.svg",
            title: "Automated Sales Reporting Made Simple",
            desc: "Easily manage your daily sales reporting with QueueBuster’s automated ADSR feature, saving you time and reducing manual work",
            bgColor: "#8ae4f626",
            imageHeight: "45rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "Automatically generates and sends daily sales reports to mall management",
                "Eliminates manual reporting, saving you time and effort.",
                "Ensures compliance with mall reporting requirements effortlessly."
            ]
        },
        {
            id: 2,
            image: "/assets/software-partners/adsr/syncMall.svg",
            title: "Stay in Sync with Mall Requirements",
            desc: "Meet all mall reporting standards effortlessly with QueueBuster, keeping your sales data compliant and accurate at all times",
            bgColor: "#F2FDEB",
            imageHeight: "44rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Simplifies adherence to mall-specific reporting standards.",
                "Keeps your sales data consistently aligned with mall regulations.",
                "Reduces the risk of penalties through reliable, automated reporting."
            ]
        },
        {
            id: 3,
            image: "/assets/software-partners/adsr/boostSales.svg",
            title: "Valuable Insights to Boost Sales",
            desc: "Beyond compliance, gain actionable insights to make smarter stock and sales decisions, helping you drive higher revenue",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
                "Offers insights into daily sales trends and customer behavior.",
                "Helps optimize inventory and stock according to demand.",
                "Empowers you to maximize revenue from your retail space with data-driven decisions."
            ]
        },
    ];

    const adsrFAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ADSR Integration improve supply tracking?
                </span>
            ),
            des: "QueueBuster ADSR-compatible POS significantly improves supply tracking by providing enhanced visibility into the quality and progress of orders from outsourced supply locations. The system integrates real-time data and advanced tracking mechanisms, allowing businesses to monitor their supply chain proactively. This advanced visibility helps identify potential supply risks early and ensures consistent quality across all orders, enhancing overall supply chain management.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What benefits does channel data management offer through QueueBuster ADSR Integration?
                </span>
            ),
            des: "Our ADSR Integration offers comprehensive benefits in channel data management by tracking downstream inventory and Secondary / Tertiary Sales. This detailed tracking helps manufacturers in better planning and partner collaboration. By staying informed about the sales and inventory levels of distributors and dealers, manufacturers can make more informed decisions, improve their supply chain efficiency, and gain a competitive edge in the market.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the order consolidation feature of QueueBuster ADSR Integration work?
                </span>
            ),
            des: "The order consolidation feature of QueueBuster ADSR Integration automates the conversion of documents received from distributors and retailers, eliminating the need for manual data entry. This automation reduces the order fulfillment cycle time and minimizes errors, leading to enhanced customer satisfaction. By streamlining the order consolidation process, businesses can process orders faster and more accurately, ensuring timely delivery and improved customer experiences.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can Shopping Centers, Malls, and Airports benefit from QueueBuster ADSR Integration?
                </span>
            ),
            des: "Shopping Centers, Malls, and Airports can greatly benefit from QueueBuster ADSR Integration as it automates the collection of tenant sales data, providing precise revenue information without administrative involvement. This automation is crucial for maintaining accurate revenue share agreements with tenants. Additionally, the insights gained from this data help in creating and implementing effective business development strategies, enhancing the overall management and profitability of retail centers.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster ADSR Integration help in reducing manual errors?
                </span>
            ),
            des: "It helps in reducing manual errors by automating various processes such as order consolidation and tax calculation. By eliminating manual data entry and automating document conversion, the system minimizes the risk of errors and ensures accuracy in data processing. This leads to improved operational efficiency and reliable data management, allowing businesses to focus on strategic growth rather than administrative tasks.",
            id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ADSR Integration facilitate partner collaboration?
                </span>
            ),
            des: "QueueBuster POS billing software facilitates partner collaboration by providing detailed insights into downstream inventory and sales data. This transparency allows manufacturers to stay informed about their partners' sales and inventory levels, enabling better planning and coordination. The enhanced visibility and data sharing foster stronger relationships with distributors and dealers, improving overall supply chain efficiency and effectiveness.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What impact does QueueBuster ADSR Integration have on order fulfillment cycle time?
                </span>
            ),
            des: "An ADSR Integrated POS impacts order fulfillment cycle time by automating the conversion of orders received from distributors and retailers. This automation eliminates the lengthy manual data entry process, allowing orders to be processed faster and more accurately. The reduction in cycle time leads to quicker order fulfillment, enhancing customer satisfaction and improving the overall efficiency of the fulfillment process.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ADSR Integration support revenue share agreements in retail centers?
                </span>
            ),
            des: "Supports revenue share agreements in retail centers by automating the collection and reporting of tenant sales data. This automation ensures that revenue information is precise and up-to-date, facilitating accurate calculation and management of revenue share agreements. The reliable data provided by the system helps in maintaining fair and transparent agreements with tenants, ensuring compliance and smooth operations.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What strategic advantages does QueueBuster ADSR Integration offer to retail businesses?
                </span>
            ),
            des: "This ADSR Integrated POS software offers several strategic advantages to retail businesses, including enhanced visibility into supply chains, improved channel data management, and streamlined order processing. These features collectively enhance operational efficiency, reduce manual errors, and provide valuable insights for strategic planning. By leveraging these advantages, retail businesses can improve their competitiveness, optimize their supply chain, and deliver superior customer experiences.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can manufacturers benefit from downstream inventory tracking through QueueBuster ADSR Integration?
                </span>
            ),
            des: "Manufacturers benefit from downstream inventory tracking through QueueBuster ADSR Integration by gaining detailed insights into the inventory levels and sales data of their distributors and dealers. This visibility helps in better planning and coordination, ensuring that inventory levels are optimized and supply chain disruptions are minimized. The ability to track downstream inventory also enhances partner collaboration and supports more informed decision-making, leading to improved efficiency and profitability.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section} style={{ alignItems: "end" }}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/ADSR.webp" alt="ADSR" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Automated Daily Sales Reporting (ADSR)</span><br />
                        <span className={styles.black_text}>With</span><span className={styles.blue_text}> QueueBuster</span><br /><span className={styles.black_text}></span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster’s ADSR integration helps you capture comprehensive sales data, including billing and transactions of your showroom, shop or kiosk in a mall or shopping complex.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                {/* <div className={styles.hero_img} style={{ height: "40rem", width: "55rem" }}><Image src="/assets/software-partners/adsr/hero-img.webp" alt="tvse" fill /></div> */}
                <div className={styles.hero_img} style={{ height: "35rem", width: "50rem" }}><Image src="/assets/software-partners/adsr/hero-img.webp" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
                {/* <h2>Key Features of POS Integration with ADSR</h2> */}
            <div className={styles.section_heading}><h3>Key Features of POS Integration with ADSR</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                <HardwareFeatures features={adsrFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={adsrFAQ} heading={"Frequently Asked Questions for QB ADSR Integrated POS Software"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopADSR